module.exports = __webpack_public_path__ + "static/Fach-504d917631688440049ce90070eae99c.svg";